import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\UpdateUserController::__invoke
* @see app/Http/Controllers/User/UpdateUserController.php
* @route '/api/user/{user}'
*/
const UpdateUserController = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateUserController.url(args, options),
    method: 'put',
})

UpdateUserController.definition = {
    methods: ["put"],
    url: '/api/user/{user}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\User\UpdateUserController::__invoke
* @see app/Http/Controllers/User/UpdateUserController.php
* @route '/api/user/{user}'
*/
UpdateUserController.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return UpdateUserController.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\UpdateUserController::__invoke
* @see app/Http/Controllers/User/UpdateUserController.php
* @route '/api/user/{user}'
*/
UpdateUserController.put = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateUserController.url(args, options),
    method: 'put',
})

export default UpdateUserController